import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HelperService } from 'src/app/services/helper.service';

@Component({
  selector: 'app-help-info-monitor',
  templateUrl: './help-info-monitor.component.html',
  styleUrls: ['./help-info-monitor.component.scss']
})
export class HelpInfoMonitorComponent {

  sanitizedUrl: SafeResourceUrl | null = null;
  loading = true; // Show a loading indicator
  videoUrl: SafeResourceUrl | null = null;
  documentUrl: SafeResourceUrl | null = null;
  isVideo = false;
  isDocument = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {payload:any,type: string },
    private helpService: HelperService,
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<HelpInfoMonitorComponent>
  ) { }

  ngOnInit(): void {
    console.log("data",this.data);
    //this.fetchContent();
    this.getHelpInfS3Url(this.data.payload,this.data.type);
    
  }

  getHelpInfS3Url(path:string,type:string) {
    let payload = { "file_path":path }
    this.helpService.getSelectedFileUrl(payload).subscribe({
      next:(res:any)=>{
        console.log("res",res);
        if(type == "doc_path") { 
          this.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
            `https://docs.google.com/gview?url=${encodeURIComponent(res)}&embedded=true`
          );
        } else {
          this.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(res);
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error fetching content:', error); // Log error details
        this.loading = false;
      }
    })
  }

  close(): void {
    // Logic to close the popup
    this.dialogRef.close(); // If using Angular Material Dialog
  }

}
